import { IListProps, List } from '@fluentui/react';

export interface IPListProps extends IListProps {}

export const IPList = (props: IPListProps) => {
  return <List {...props} />;
};
